module.exports = ".card img {\n  width: 80%;\n  margin: 25px; }\n\n.card p {\n  font-size: 11px;\n  font-weight: bold;\n  color: #444;\n  text-align: center;\n  margin-bottom: 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home-sidebar/home-sidebar.component.scss
// module id = ./src/app/components/home/home-sidebar/home-sidebar.component.scss
// module chunks = main